import { render, staticRenderFns } from "./DialogBillingReminder.pug?vue&type=template&id=d4fddd70&scoped=true&lang=pug&"
import script from "./DialogBillingReminder.vue?vue&type=script&lang=js&"
export * from "./DialogBillingReminder.vue?vue&type=script&lang=js&"
import style0 from "./DialogBillingReminder.vue?vue&type=style&index=0&id=d4fddd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fddd70",
  null
  
)

export default component.exports